import { User } from '../classes/User.class';

/**
 * returns an array of Super User assigend to an OT
 */
export const arrSuperUsers = (users: User[]): User[] => {
  const arr: User[] = [];
  users.forEach(user => {
    if (user.role === 'super_admin') {
      arr.push(user);
    }
  });
  return arr;
};
